import React, { useCallback, useMemo } from 'react';
import { SelectProps as AntSelectProps, Select as AntSelect } from 'antd';
import { OptionsPage, OptionType } from '../queryClient';
import { getPageOptions, withDefaultOption } from '../form';
import { isPopupScrolledToBottom } from '../utils/popupScroll';

export interface SelectProps<ValueType = any>
  extends AntSelectProps<ValueType, any> {
  defaultOption?: OptionType;
  defaultOptions?: OptionType[];
  onScrollDown?: () => PromiseLike<any>;
  pages?: OptionsPage[];
}

export const Select = <ValueType = any,>(props: SelectProps<ValueType>) => {
  const {
    defaultOption,
    defaultOptions,
    loading,
    onPopupScroll,
    onScrollDown,
    options,
    pages,
    ...rest
  } = props;
  const handlePopupScroll = useCallback(
    async (event: any) => {
      onPopupScroll?.(event);
      if (onScrollDown) {
        const target = event.target;

        if (!loading && isPopupScrolledToBottom(target)) {
          target.scrollTo(0, target.scrollHeight);
          await onScrollDown();
        }
      }
    },
    [loading, onPopupScroll, onScrollDown],
  );
  const pageOptions = useMemo(
    () =>
      pages
        ? withDefaultOption(
            getPageOptions(pages, defaultOption),
            0,
            defaultOptions,
          )
        : defaultOptions,
    [defaultOption, defaultOptions, pages],
  );

  return (
    <AntSelect
      {...rest}
      loading={loading}
      onPopupScroll={
        onScrollDown || onPopupScroll ? handlePopupScroll : undefined
      }
      options={options ?? pageOptions}
    />
  );
};
